<div class="progress-bar-wrapper">
  <div class="progress-bar">
    <ng-container *ngFor="let step of stepsArray; let i = index">
      <div class="section" [style.width.%]="100 / totalSteps" [style.left.%]="i * (100 / totalSteps)"
        [class.active]="step <= currentStep">
        <div class="circle" *ngIf="step > 1" [class.active]="isStepActive(step)"><label
            *ngIf="(step-1) <= currentStep">{{
            step - 1 }}</label></div>
      </div>
    </ng-container>
  </div>
</div>